import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { LayoutTranslation } from '../components/main/combined-menu/layout-translation';

@Injectable()
export class DmbTitleStrategy extends TitleStrategy {
  private title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot) {
    const title = this.buildTitle(snapshot) ?? this.fromUrl(snapshot.url);

    const titleTranslation = title ? LayoutTranslation.getTranslations()[title as keyof LayoutTranslation] : undefined;

    this.title.setTitle(titleTranslation ? `${titleTranslation} | DMB` : 'DMB');
  }

  private fromUrl(url: string) {
    const match = url.match(/^\/([^/]+)/);
    return match ? match[1] : null;
  }
}
